import { isRoundRobinMethod } from './isRoundRobinMethod';

// Short form of the create-form wording, not "collective" / "round robin" — the
// column and the summary row are already headed "Interview panel", so the chip
// only carries what separates one from the other. Anything that isn't round
// robin (incl. null on legacy templates) is the whole panel.
// Matches on "not collective" rather than naming a distribution, so a legacy
// row still reads as a single-member panel after the schema dropped its method.
export const getPanelTypeLabel = (method?: string | null): string =>
  isRoundRobinMethod(method) ? 'Single member' : 'Whole panel';
